import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import {Box, Button, TextField,Grid, Typography} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import Divider from '@mui/material/Divider';
import { Link, useNavigate,useParams } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

function AddSerial() {
  const navigate = useNavigate();
  const [masterInput, setMaster] = useState({
    series_name: '',
    starting_month: '',
    end_month: '',
    year: '',  // Add year field
    error_list:[],
  });
  const handleInput = (e) => {
    e.persist();
    setMaster({...masterInput, [e.target.name]: e.target.value})
    //console.log('Props---',this.props);
  }

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor('#F40B27'),
      apple: createColor('#A38A00'),
      steelBlue: createColor('#5C76B7'),
      violet: createColor('#BC00A3'),
    },
    button: { // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    }, 
  });

  const submitSerial = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data = {
        series_name: masterInput.series_name,
        starting_month: masterInput.starting_month,
        end_month:masterInput.end_month,
        year: masterInput.year,
        user_id:userId,
    }

    axios.post(`/api/store_serial`,data).then(res =>{
      if(res.data.status === 200){
        swal("Success",res.data.message,"success");
        document.getElementById('CATEGORY_FORM').reset();
        navigate('/certificates/show_serial');
      }
      else if(res.data.status === 400){
        setMaster({...masterInput,error_list:res.data.errors});
      }
    });
  }


 {/* return (
   {/* <div>
    <Navbar/>
    <div className = "card px-8 m-5">
      <div className = "card-header">
      <Grid container spacing={70}>
         <Grid item xs={8}>
           <h4>Add Serial</h4>
           </Grid>
           <Grid item xs={4}>
           <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/show_serial" variant="contained" color="apple">Back</Button>
          </ThemeProvider>
           </Grid>

           </Grid>
      </div>
    <form onSubmit={submitSerial} id="CATEGORY_FORM">
    <form id= "store" onSubmit={this.handleSubmit} onChange={this.handleChange} >
   
            <Grid container spacing={5}>
            <Grid item xs={15}>
            <Box paddingTop={1} borderRadius={1} paddingLeft={40} paddingRight={40}>
            
            <TextField fullWidth name="series_name" id="outlined-basic" onChange={handleInput} value={masterInput.series_name} margin="normal" label="series_name" variant="outlined"/>
            <span style={{color: "red"}} >{masterInput.error_list.series_name}</span>

           {/* <TextField fullWidth name="starting_month" id="outlined-basic" onChange={handleInput} value={masterInput.starting_month} margin="normal" label="starting_month" variant="outlined"/>
            <span style={{color: "red"}} >{masterInput.error_list.starting_month}</span>
            <div className="form-group">
            <label className="required" style={{ marginBottom: "7px" }}>starting_month</label>
           {/* <select name="starting_month" className="form-control" >
            <option value="">-- Select month --</option>
                                                    <option value="jan">jan</option>
                                                    <option value="Feb">Feb</option>
                                                    <option value="Mar">Mar</option>
                                                    <option value="apl">apl</option>
                                                    <option value="may">may</option>
                                                    <option value="jun">jun</option>
                                                    <option value="july">july</option>
                                                    <option value="aug">aug</option>
                                                    <option value="sep">sep</option>
                                                    <option value="oct">oct</option>
                                                    <option value="nov">nov</option>
                                                    <option value="dec">dec</option>
          </select>
          <select id="month">
    <option value="1">January</option>
    <option value="2">February</option>
    <option value="3">March</option>
    <option value="4">April</option>
    <option value="5">May</option>
    <option value="6">June</option>
    <option value="7">July</option>
    <option value="8">August</option>
    <option value="9">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
</select>
            <span style={{color: "red"}} >{masterInput.error_list.starting_month}</span>
            </div>
            <TextField fullWidth name="end_month" id="outlined-basic" onChange={handleInput} value={masterInput.end_month} margin="normal" label="end_month" variant="outlined"/>
            <span style={{color: "red"}} >{masterInput.error_list.end_month}</span>
            </Box>
            </Grid>
             </Grid>
             <ThemeProvider theme={theme}>
             <Box marginTop={1} display="flex" padding={3} borderRadius={5} alignItems="center" justifyContent={'center'}>
            <Button
            style={{
          maxWidth: "200px",
          maxHeight: "100px",
          minWidth: "50px",
          minHeight: "30px"
        }}
        color='apple'
             type="submit" variant="contained">Add</Button>
            </Box>
            </ThemeProvider>
    </form>
    </div>
      </div>*/}
      return (
   <div>
        <form onSubmit={submitSerial} id="CATEGORY_FORM">
        <div className="row" style={{ marginTop: 20, width: "97%" }}>
                        // <div className="col-sm-1"></div>
                        <div className="col-sm-12" style={{ marginLeft: 40 }}>
                            <div className="card">
                                <div className="card-header">
                                <div class="d-flex justify-content-between">
                                <h4><b>Add Serial</b></h4>
                                <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/show_serial" variant='contained' color='apple'>Back</Button>
           </ThemeProvider></div></div>
                                <div className="card-body">
                                    <div className="row">
                                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>series_name</label>
                                                <input type="text" name="series_name" id="series_name" className="form-control" placeholder="Enter series_name" onChange={handleInput} value={masterInput.series_name}/>
                                                <span style={{ color: "red" }}>
                                                  {masterInput.error_list.series_name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>starting_month</label>
                                                <select name="starting_month" id="starting_month" className="form-control"  onChange={handleInput} value={masterInput.starting_month}>
                                                    <option value="">-- starting_month --</option>
                                                    <option value="January">January</option>
                                                    <option value="February">February</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                <span style={{ color: "red" }}>
                                                  {masterInput.error_list.starting_month}
                                                </span>
                                            </div>
                                         </div> 
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>end_month</label>
                                                <select name="end_month" id="end_month" className="form-control"  onChange={handleInput} value={masterInput.end_month} >
                                                    <option value="">-- end_month  --</option>
                                                    <option value="January">January</option>
                                                    <option value="February">February</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                                <span style={{ color: "red" }}>
                                                  {masterInput.error_list.end_month}
                                                </span>
                                            </div>
                                            </div>
                                            <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Year</label>
                                                <select
                                                  name="year"
                                                  id="year"
                                                  className="form-control"
                                                  onChange={handleInput}
                                                  value={masterInput.year}
                                                 >
                                                 <option value="">-- Select year --</option>
                                               {/* Add year options or generate dynamically based on your requirements */}
                                                 <option value="2023">2023</option>
                                                 <option value="2024">2024</option>
                                                <option value="2025">2025</option>
                                                 {/* Add more years as needed */}
                                                  </select>
                                               </div>
                                            </div>
                                        {/*<div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                       {/* <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>series_name</label>
                                                <input type="text" name="series_name" id="series_name" className="form-control" placeholder="Enter series_name" onChange={handleInput} value={masterInput.series_name}/>
                                                <span style={{ color: "red" }}>
                                                  {masterInput.error_list.series_name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12" style={{ marginBottom: "15px" }}>
                                          <div className="form-group ">
                                              <label className="required" style={{ marginBottom: "7px" }}>Item Description</label>
                                              <textarea type="text" name="itemdesc" id="itemdesc" className="form-control" placeholder="Enter Item Description" onChange={handleInput} value={masterInput.itemdesc}/>
                                              <span style={{ color: "red" }}>
                                                  {masterInput.error_list.itemdesc}
                                                </span>
                                          </div>
                                        </div>*/}
                                        
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Add</button></div>
                            </div>
                            
                        </div>
                        
                    </div>
               </form>
               </div>
               
  );
}



export default AddSerial